import { render } from "./TagEdit.vue?vue&type=template&id=1bb35328"
import script from "./TagEdit.vue?vue&type=script&lang=js"
export * from "./TagEdit.vue?vue&type=script&lang=js"
script.render = render

export default script